export default __webpack_public_path__ + "static/media/signin.80504031.png";